import $ from 'jquery';

$(function() {
    $('.orbit.hero').on('beforeslidechange.zf.orbit', function (evt, orbit) {
        $('.orbit-slide .callout').fadeOut(function () {
            $('.orbit-slide .callout').fadeIn();
        });
    });
});
